import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
    danhSachGroup: [],
    danhSachGroupPaging: [],
    chiTietGroup: {},
    danhSachVaiTroTheoGroup: [],
    danhSachQuyenTheoGroup: [],
    danhSachUserNotInGroup: []
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
